import { LuPanelRightOpen } from "react-icons/lu";
import useTitanApp from "../../../../../../hooks/useTitanApp";
import TranscriptionTimeline from "./components/TranscriptionTimeline";
import {
  setFirstPatientPanelTitle,
  setTogglePatientPanelOne,
} from "../../../../../../dispatchers/patientDispatchers";

export default function PatientTranscript() {
  const { appState } = useTitanApp();
  const { darkMode } = appState || {};

  const handleFirstPatientPanelCollapsing = () => {
    setTogglePatientPanelOne(true);
    setFirstPatientPanelTitle("Transcript");
  };

  return (
    <div className="pc-tabbed-content patient-transcript-wrapper">
      <div className="section-title">
        <LuPanelRightOpen
          className="collapse-icon"
          color={darkMode ? "#fff" : "#0a0a0a"}
          onClick={handleFirstPatientPanelCollapsing}
        />
        <h5>Consultation transcript</h5>
      </div>

      <TranscriptionTimeline />
    </div>
  );
}
